export default __webpack_public_path__ + "static/media/profile-nav.f7941e72.svg";